import { schema } from 'normalizr';

export const name = 'groups';

export const groupSchema = new schema.Entity(name);

export const groupsCollectionSchema = new schema.Array(groupSchema);
groupSchema.define({ subgroups: groupsCollectionSchema });
